// extracted by mini-css-extract-plugin
module.exports = {"section":"careers_section__poIRf","position":"careers_position__0XZqh","workInfoWrapper":"careers_workInfoWrapper__Y91Oq"};